import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const DataButtonWidget: WidgetRegistryEntry = {
  name: "DataButton",
  configuration: () => import("./configuration").then((m) => m.DataButtonWidgetConfiguration),
  component: () => import("./data-button-widget.component").then((m) => m.DataButtonWidgetComponent)
};
